import { render, staticRenderFns } from "./RestoreUser.vue?vue&type=template&id=3a1336f0&scoped=true&"
import script from "./RestoreUser.vue?vue&type=script&lang=js&"
export * from "./RestoreUser.vue?vue&type=script&lang=js&"
import style0 from "./RestoreUser.vue?vue&type=style&index=0&id=3a1336f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1336f0",
  null
  
)

export default component.exports